import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useAssociatedObjectsCardContentContext } from '../context/AssociatedObjectsCardContext';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';

/*
 z-index temporary hack as we're loading a UIFloatingFormControl inside
 the Custom object chicklet - .private-form__control__overlay has a white background on hover

 trellis doesn't have support for MERCURY_LAYER yet
*/
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ButtonSection = styled.div.withConfig({
  displayName: "ChickletHoverActions__ButtonSection",
  componentId: "sc-15yko8y-0"
})(["top:0;right:0;position:absolute;z-index:1;", ""], ({
  $isTrellis
}) => $isTrellis && `
    margin-top: 12px;
    margin-right: 12px;
  `);
const propTypes = {
  Buttons: PropTypes.elementType.isRequired,
  buttonsProps: PropTypes.object,
  children: PropTypes.node.isRequired
};
const ChickletHoverActions = ({
  Buttons,
  buttonsProps,
  children
}) => {
  const {
    isEmbedded
  } = useAssociatedObjectsCardContentContext();
  const theme = useTheme();
  const [shouldShowActions, setShouldShowActions] = useState(false);
  const handleMouseEnter = useCallback(() => {
    setShouldShowActions(true);
  }, []);
  const handleMouseLeave = useCallback(() => {
    setShouldShowActions(false);
  }, []);

  // disable preview and remove when in iframe as they don't work well in
  // small windows, as the panel header is confusing when confined in an iframe
  // as its buttons (specifically the "X") can get confused for the host app's
  // buttons/navigation
  // for more info see https://git.hubteam.com/HubSpot/customer-data-sidebar/pull/1154
  if (isEmbedded) {
    return children;
  }

  // conditionally renders Buttons based on hover
  return /*#__PURE__*/_jsxs("div", {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    "data-selenium-test": "preview-header",
    "data-test-id": "preview-header",
    children: [children, shouldShowActions && /*#__PURE__*/_jsx(ButtonSection, {
      $isTrellis: isTrellisTheme(theme),
      children: /*#__PURE__*/_jsx(Buttons, Object.assign({}, buttonsProps))
    })]
  });
};
ChickletHoverActions.propTypes = propTypes;
export default ChickletHoverActions;